<template>
  <header class="header">		
		<div class="container">
			<div class="header-nav">
				<div class="main-menu-wrapper w-100 d-flex justify-content-between">
					<div class="navbar-logo">
						<router-link class="header-logo" to="/home/index">
							<img src="@/assets/img/logo.svg" class="logo" alt="Logo">
						</router-link>
					</div>
					<div class="header-btn d-flex align-items-center">
						<div class="dropdown">
							<a href="javascript:void(0);" data-bs-toggle="dropdown">
								<div class="booking-user d-flex align-items-center">
									<span class="user-img">
										<img src="@/assets/img/profiles/avatar-02.jpg" alt="user">
									</span>
									<div class="ms-2 d-none d-sm-block">
										<h6 class="fs-14 fw-medium">Adrian Reniques</h6>
										<p class="fs-12">Demo user</p>
									</div>
								</div>
							</a>
							<ul class="dropdown-menu p-2">
								<li><router-link class="dropdown-item d-flex align-items-center" to="/"><i class="ti ti-logout me-1"></i>Logout</router-link></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>
